module.exports = __webpack_public_path__ + "img/抽奖.029a83c1.png";